// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"702":"story","715":"list","962":"home"}[chunkId] || chunkId) + "-" + {"137":"8f1952ff70d3f8ea3634","143":"47ba8ac3da7dde02569c","702":"033382af66dea55f61f2","715":"8d8c2f26846ddac33f5b","939":"f14b38a0009831659e2a","962":"b15e72fd2d0cd628838f"}[chunkId] + ".css";
};